'use strict';

/* jshint -W098 */
angular.module('mean.databases').controller('DatabasesExtrasController', ['$scope', 'Global', 'MeanUser', 'userService', 'Trades', 'tradeCodeService', 'toaster', '$filter', 'Extras', 'aceUtils', 'ngDialog', 'ProjectTasks', 'taskListService', 'Builders', 'Projects', 'contactService',
  function($scope, Global, MeanUser, userService, Trades, tradeCodeService, toaster, $filter, Extras, aceUtils, ngDialog, ProjectTasks, taskListService, Builders, Projects, contactService) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.sortType = ['project_id.builder.name', 'project_id.name'];
    $scope.sortReverse = false;

    $scope.user = MeanUser.user;
    $scope.newMIOTasks = [];

    $scope.$on('extrasLoadEvent', function (event, data) {
        console.log('extrasLoadEvent');
        
        $scope.selectedProject = data.searchProp.project_id;
        $scope.selectedPhase = data.searchProp.phase;
        $scope.selectedLot = data.searchProp.lot;

        userService.getMainAccount($scope.user.username).then(function(main_account) {
            $scope.main_account = main_account;
            Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
                $scope.my_trade = trade[0];

                Extras.query({'project_id': data.searchProp.project_id,
                    'trade_id': $scope.my_trade._id, 
                    'trade': $scope.user.trade[0],
                    'status': data.searchProp.status,
                    'phase': data.searchProp.phase,
                    'lot': data.searchProp.lot,
                    'task': data.searchProp.task }, function(extrasdb) {
                        $scope.extras = extrasdb;

                        _.each($scope.extras, function(extra) {
                            $scope.updateStatusFlags(extra);
                        });
                });

                // if($scope.$parent.projects.length > 0) {
                //     $scope.projects = $filter('orderBy')($scope.$parent.projects, 'name');
                // } else {
                    $scope.all_projects = $filter('orderBy')($scope.$parent.all_projects, 'name');
                // }

                $scope.extra_tasks = angular.copy($scope.$parent.trade_tasks);
                _.remove($scope.extra_tasks, function(task) {
                    return task.task_code === 'All';
                });
            });
        });
    });

    $scope.updateStatusFlags = function(item) {
        if(item.status === 'Open') {
            item.open = true;
        } else if(item.status === 'Billed') {
            item.billed = true;
        } else if(item.status === 'Paid') {
            item.paid = true;
        } 
    };

    $scope.statusChange = function(item) {
        if(item.status === 'Open') {
            //current status is open, lets see
            //what it should be now.
            item.open = false;
            if(item.billed) {
                item.status = 'Billed';
                item.date_billed = new Date();
            } else if(item.paid) {
                item.status = 'Paid';
            } else {
                //status change will happen by clicking
                //any one of the three
                item.open = true;
            }
        } else if(item.status === 'Billed') {
            item.billed = false;
            if(item.open) {
                item.status = 'Open';
            } else if(item.paid) {
                item.status = 'Paid';
                item.date_paid = new Date();
            } else {
                item.billed = true;
            }
        } else if(item.status === 'Paid') {
            item.paid = false;
            if(item.open) {
                item.status = 'Open';
            } else if(item.billed) {
                item.status = 'Billed';
            } else {
                item.paid = true;
            }
        }

        item.$update(function(success) {
            item = success;

            $scope.updateStatusFlags(item);

            toaster.pop('success', 'Extras Database', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Extras Database', error);
        });
    };

    $scope.editFPO = function(item) {
        item.fpoEditing = true;
    };

    $scope.updateFPO = function(item) {
        if(!item.fpoEditing) return;
        item.$update(function(success) {
            item = success;
            item.fpoEditing = false;
            $scope.updateStatusFlags(item);
        }, function(error) {
            toaster.pop('error', 'Extras Database', error);
        });
    };

    $scope.doneProjectNameEditing = function (item) {
        $scope.lots = $filter('orderBy')(item.lots, ['phase', 'number']);
        $scope.newMIOTasks = $filter('filter')($scope.trade_tasks, { geoLocation: item['geoLocation'], projectType: item['projectType']}, true);

        Extras.query({'project_id': $scope.returnedOptions.project_id._id,
            'trade_id': $scope.my_trade._id,
            'trade': $scope.user.trade[0] }, function(extrasdb) {
            //$scope.extras = extrasdb;
            $scope.returnedOptions.awa_number = $scope.nextAWANumber(extrasdb);
        });
    };

    $scope.extraUpdate = function(item) {
        item.labor = item.hours * item.rate;
        item.total = item.labor*1 + item.material*1 + item.equipment*1;
    };

    $scope.editExtraOperation = function (item, idx) {
        $scope.lots = item.project_id.lots;

        //var proj = $filter('filter')($scope.projects, { '_id': $scope.selectedProject }, true)[0];
        //$scope.selectedProject = item.project_id;
        var lot = $filter('filter')($scope.lots, { 'number': item.lot }, true)[0];
        var task = $filter('filter')($scope.extra_tasks, { 'task_code': item.task }, true)[0];

        $scope.returnedOptions = {
            project_id: item.project_id,
            extra_task: task,
            lot: lot,
            hours: $filter('number')(item.hours, 2),
            rate: item.rate,
            labor: item.labor,
            material: item.material,
            equipment: item.equipment,
            total: item.total,
            awa_number: aceUtils.padDigits(item.awa_number, 6),
            status: item.status,
            date: new moment(item.date),
            date_billed: (item.date_billed) ? new moment(item.date_billed) : '',
            date_paid: (item.date_paid) ? new moment(item.date_paid) : '',
            fpo: item.fpo,
            note: item.note,
        };

        ngDialog.openConfirm({
            template: 'databases/views/tmpl/databases-edit-extra.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            if(!$scope.returnedOptions.lot) {
                toaster.pop('error', 'Lot Selection', 'You must select a lot.');
                //item.project_id = item.originalProject;
                return;
            }

            if($scope.returnedOptions.extra_task === '') {
                toaster.pop('error', 'Task Selection', 'You must select a task.');
                //item.project_id = item.originalProject;
                return;
            }

            ProjectTasks.query({'project_id': $scope.returnedOptions.project_id._id,
                'phase': $scope.returnedOptions.lot.phase,
                'lot': $scope.returnedOptions.lot.number,
                'task_code': $scope.returnedOptions.extra_task.task_code }, function(tasks) {

                var switch_projects = false;
                if(item.project_id !== $scope.returnedOptions.project_id) {
                    switch_projects = true;
                }

                if(tasks.length === 1) {
                    item.project_id = $scope.returnedOptions.project_id;
                    item.project_task_id = tasks[0];
                    item.phase = $scope.returnedOptions.lot.phase;
                    item.lot = $scope.returnedOptions.lot.number;
                    item.task = $scope.returnedOptions.extra_task.task_code;
                    item.awa_number = $scope.returnedOptions.awa_number;
                    item.hours = $scope.returnedOptions.hours;
                    item.rate = $scope.returnedOptions.rate;
                    item.labor = $scope.returnedOptions.labor;
                    item.material = $scope.returnedOptions.material;
                    item.equipment = $scope.returnedOptions.equipment;
                    item.total = $scope.returnedOptions.total;
                    item.status = $scope.returnedOptions.status;
                    item.date = new Date($scope.returnedOptions.date);
                    item.date_billed = new Date($scope.returnedOptions.date_billed);
                    item.date_paid = new Date($scope.returnedOptions.date_paid);
                    item.fpo = $scope.returnedOptions.fpo;
                    item.note = $scope.returnedOptions.note;

                    item.$update(function(success) {
                        if(switch_projects) {
                            $scope.extras.splice(idx, 1);
                        } else {
                            success.date = new Date(success.date);
                            success.date_billed = (success.date_billed) ? new moment(success.date_billed) : null;
                            success.date_paid = (success.date_paid) ? new moment(success.date_paid) : null;
                            $scope.extras[idx] = success;
                            $scope.updateStatusFlags($scope.extras[idx]);
                        }
                        toaster.pop('success', 'Extras', 'Database updated');
                    }, function(error) {
                        toaster.pop('error', 'Extras Error', 'There is an issue with updating the extra');
                    });
                } else {
                    toaster.pop('error', 'Project Task Error', 
                        'Could not get a project tasks from the database. ' +
                        'Selected Project/Lot/Task most likely not scheduled.');
                    return;
                }
            });            
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    function stringIsNumber(s) {

        var x = +s; // made cast obvious for demonstration
        return x.toString() === s;
    };

    $scope.nextAWANumber = function(extras) {
        //extras has the most current list
        if(extras.length > 0) {
            var unique_numbers = $filter('unique')(extras, 'awa_number');
            var numbers_only = _.remove(unique_numbers, function(number) {
                return stringIsNumber(number.awa_number);
            });

            unique_numbers = $filter('orderBy')(numbers_only, 'awa_number*1');

            for(var i=0; i<1000000; i++) {
                //we've ordered the list so the first entries should
                //be numbers.  First check and see if the string
                //represents a number.  
                if(unique_numbers[i] && 
                    stringIsNumber(unique_numbers[i].awa_number)) {

                    //we know this awa number is a number.  now
                    //we need to find the next number we can use.
                    if(Number(unique_numbers[i].awa_number) !== i+1) {
                        return aceUtils.padDigits(i+1, 6);
                    }
                } else {
                    return aceUtils.padDigits(i+1, 6);
                }
            }
        } else {
            return aceUtils.padDigits(1, 6);
        }
    };

    $scope.changeBuilder = function(builder) {
        if(!builder) return;
        $scope.projects = [];
        $scope.tasks = [];
        $scope.phases = [];
        $scope.lots = [];
        $scope.bid_tasks = [];
        $scope.trades = [];

        $scope.projects = $filter('filter')($scope.all_projects, {
            'company_code': builder.company_code, 
            'trade_code': builder.trade_code }, true);

        $filter('orderBy')($scope.projects, 'name');
    };

    $scope.getBuilderList  = function() {
        userService.getMainAccount($scope.user.username).then(function(main_account) {
            $scope.main_account = main_account;
            contactService.getMyContacts($scope.main_account._id).then(function(contacts) {
                $scope.builders = [];

                Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
                    trade[0].trade_code = trade[0].trade_code?trade[0].trade_code:
                                                        tradeCodeService.getCode(trade[0].trade)
                    $scope.my_trade = trade[0];
                    $scope.builders.push(trade[0]);

                    contacts.builders.forEach(function(builder) {
                        Builders.query({'builder': builder._id}, function(builders) {
                            _.each(builders, function(builder) {
                                builder.company_code = aceUtils.padDigits(builder.company_code, 3);
                                builder.trade_code = builder.trade_code?builder.trade_code:
                                                            tradeCodeService.getCode(builder.trade)
                                $scope.builders.push(builder);
                            });
                        });
                    });
                });
            });
        });
    };

    $scope.makeAWAExplicit = function () {
        $scope.strip_leading_zeros = false;
    };

    $scope.newExtraOperation = function () {
        //var item = new Extras();

        $scope.new_extra = true;
        $scope.strip_leading_zeros = true;
        $scope.lots = [];
        
        //if the tasks have not been defined, do it now
        if(!$scope.extra_tasks) {
            $scope.getBuilderList();
            taskListService.getByTrade(tradeCodeService.getCode(
                    $scope.user.trade[0])).then(function(result) {
                $scope.extra_tasks = $filter('orderBy')(result, 'task_code');
            });
        }

        $scope.returnedOptions = {
            project_id: '',
            extra_task: '',
            lot: '',
            hours: 0,
            rate: 0,
            labor: 0,
            material: 0,
            equipment: 0,
            total: 0,
            status: 'Open',
            awa_number: '',//aceUtils.padDigits($scope.nextAWANumber(), 6),
            date: new Date(),
            note: '',
        };

        ngDialog.openConfirm({
            template: 'databases/views/tmpl/databases-edit-extra.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            if(!$scope.returnedOptions.lot) {
                toaster.pop('error', 'Lot Selection', 'You must select a lot.');
                //item.project_id = item.originalProject;
                return;
            }

            if($scope.returnedOptions.extra_task === '') {
                toaster.pop('error', 'Task Selection', 'You must select a task.');
                //item.project_id = item.originalProject;
                return;
            }

            // Extras.query({'project_id': $scope.returnedOptions.project_id._id,
            //     'trade_id': $scope.my_trade._id,
            //     'trade': $scope.user.trade[0] }, function(extrasdb) {
            //         $scope.extras = extrasdb;

                var total_tasks = $scope.returnedOptions.lot.length * 
                    $scope.returnedOptions.extra_task.length;

                var hours = $scope.returnedOptions.hours / total_tasks;
                var labor = $scope.returnedOptions.labor / total_tasks;
                var material = $scope.returnedOptions.material / total_tasks;
                var equipment = $scope.returnedOptions.equipment / total_tasks;
                var total = $scope.returnedOptions.total / total_tasks;

                _.each($scope.returnedOptions.lot, function(lot) {
                    _.each($scope.returnedOptions.extra_task, function(task) {
                        ProjectTasks.query({'project_id': $scope.returnedOptions.project_id._id,
                            'phase': lot.phase,
                            'lot': lot.number,
                            'task_code': task.task_code }, function(tasks) {

                            var item = new Extras();

                            if(tasks.length === 1) {
                                item.project_id = $scope.returnedOptions.project_id._id;
                                item.project_task_id = tasks[0]._id;
                                item.trade_id = $scope.my_trade._id;
                                item.trade = $scope.user.trade[0];
                                item.phase = lot.phase;
                                item.lot = lot.number;
                                item.task = task.task_code;
                                if($scope.strip_leading_zeros)
                                  item.awa_number = $scope.returnedOptions.awa_number.replace(/^0+/, '');
                                else
                                  item.awa_number = $scope.returnedOptions.awa_number;
                                item.hours = hours;
                                item.rate = $scope.returnedOptions.rate;
                                item.labor = labor;
                                item.material = material;
                                item.equipment = equipment;
                                item.total = total;
                                item.status = 'Open';
                                item.fpo = 'TBD';
                                item.date = new Date();
                                item.note = $scope.returnedOptions.note;

                                item.$save(function(success) {
                                    // success.date = new moment(success.date);
                                    // success.date_billed = new moment(success.date_billed);
                                    // success.date_paid = new moment(success.date_paid);
                                    // item = success;
                                    // $scope.updateStatusFlags(item);

                                    // $scope.extras.push(item);
                                    toaster.pop('success', 'Extras', 'Database updated');
                                }, function(error) {
                                    toaster.pop('error', 'Extras Error', 'There is an issue with updating the extra');
                                });
                            } else {
                                toaster.pop('error', 'Project Task Error', 
                                    'Could not get a project tasks from the database. ' +
                                    'Selected Project/Lot/Task most likely not scheduled.');
                                return;
                            }
                        });
                    });
                });
            //});  

            $scope.new_extra = false;  
            //$scope.next_awa_number += 1;
        }, function (value) {
            //Do something
            $scope.new_extra = false;
            console.log('in the do something section');
        });
    };

    $scope.removeExtras = function(item) {
        item.$delete(function(success) {
            toaster.pop('Hours', 'success', 'Hours removed from database');
            var idx = $scope.extras.indexOf(item);
            $scope.extras.splice(idx, 1);
        }, function(error) {
            toaster.pop('Hours', 'error', error);
        });
    };

    $scope.removeExtrasOperation = function(item) {
        ngDialog.openConfirm({
            template:
                '<h2>Delete Extras Data</h2>' +
                '<p>This operation will delete extra data from the system</p>' +
                '<p>Are you sure you want to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.removeExtras(item);
        }, function (value) {
            //Do something 
            console.log('in the do something section');
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/databases-extras.js